import React from 'react';
import PropTypes from 'prop-types';
import Header from '../Header/Header';
import Banner from '../Header/Banner';
import SubHeader from '../Header/SubHeader';

const Block = (props) => {
  const { headerTitle, children, showSubHeader } = props;
  return (
    <>
      <Header {...props} title={headerTitle} />
      <Banner />
      {showSubHeader && <SubHeader {...props} title={headerTitle} />}
      {children}
    </>
  );
};

export default Block;

Block.propTypes = {
  headerTitle: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.shape(), PropTypes.array]).isRequired,
  showSubHeader: PropTypes.bool,
};

Block.defaultProps = {
  headerTitle: process.env.REACT_APP_NAME,
  showSubHeader: undefined,
};
